import { useState } from "react";
import { Button } from "react-bootstrap";
import { lockDatabase, unlockDatabase } from "../services/configApi";


const DbLockButton = ({ canSeeAdmin, isOpen, dbLocked, onDbLockChange }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);

    if (!canSeeAdmin || !isOpen) return null;

    const handleLockDb = async () => {
        if (isSubmitting || dbLocked) return;

        setIsSubmitting(true);
        try {
            await lockDatabase();
            if (typeof onDbLockChange === "function") {
                onDbLockChange(true);
            }
            alert("Baza została zablokowana do zapisu.");
        } catch (error) {
            if (error?.response?.status === 409) {
                const apiMessage =
                    error?.response?.data?.detail ||
                    error?.response?.data?.title ||
                    "Baza jest już zablokowana lub operacja nie może zostać wykonana.";
                alert(apiMessage);
            } else {
                alert("Nie udało się zablokować bazy do zapisu.");
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleUnlockDb = async () => {
        if (isSubmitting || !dbLocked) return;

        setIsSubmitting(true);
        try {
            await unlockDatabase();
            if (typeof onDbLockChange === "function") {
                onDbLockChange(false);
            }
            alert("Baza została odblokowana do zapisu.");
        } catch (error) {
            if (error?.response?.status === 409) {
                const apiMessage =
                    error?.response?.data?.detail ||
                    error?.response?.data?.title ||
                    "Baza nie może zostać odblokowana w tym momencie.";
                alert(apiMessage);
            } else {
                alert("Nie udało się odblokować bazy do zapisu.");
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <li className="sb__item sb__item--action">
            <Button
                variant={dbLocked ? "success" : "danger"}
                className="sb__action-btn"
                onClick={dbLocked ? handleUnlockDb : handleLockDb}
                disabled={isSubmitting}
            >
                {dbLocked
                    ? (isSubmitting ? "Odblokowywanie..." : "Odblokuj bazę do zapisu")
                    : isSubmitting
                        ? "Blokowanie..."
                        : "Zablokuj bazę do zapisu"}
            </Button>
        </li>
    );
};

export default DbLockButton;
